import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Layout from '@/components/Layout.vue'
import DeviceList from '@/views/DeviceList.vue'
import DataReport from '@/views/DataReport.vue'
import AlarmRecord from '@/views/AlarmRecord.vue'
import RuleConfig from '@/views/RuleConfig.vue'
import DeviceType from '@/views/DeviceType.vue'
import DeviceTemplate from '@/views/DeviceTemplate.vue'
import FirmwareManage from '@/views/FirmwareManage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/reports',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'reports',
        name: 'DataReport',
        component: DataReport,
        meta: { title: '首页' }
      },
      {
        path: 'devices',
        name: 'DeviceList',
        component: DeviceList,
        meta: { title: '设备列表' }
      },
      {
        path: 'device-types',
        name: 'DeviceType',
        component: DeviceType,
        meta: { title: '设备类型' }
      },
      {
        path: 'templates',
        name: 'DeviceTemplate',
        component: DeviceTemplate,
        meta: { title: '设备模板' }
      },
      {
        path: 'firmwares',
        name: 'FirmwareManage',
        component: FirmwareManage,
        meta: { title: '固件管理' }
      },
      {
        path: 'rules',
        name: 'RuleConfig',
        component: RuleConfig,
        meta: { title: '规则配置' }
      },
      {
        path: 'alarms',
        name: 'AlarmRecord',
        component: AlarmRecord,
        meta: { title: '告警记录' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
